// @flow
import * as React from 'react';

import { Api, createApiData } from 'app/common/context/Api';
import shopApi from 'app/actions/shopApi';
import * as paymentTypes from 'app/common/actions/shop/order/paymentTypes';
import i18n from 'app/i18n';


export const PaymentMethods = createApiData();

const requestsData = {
  shippingMethods: {
    path: 'payment_methods',
    type: 'get',
    cbErrorTextCreate: (/* error */) => (i18n.t('shop:error_api_payment_methods')),
    autoRequest: true,
  },
};

export type PaymentMethod = {
  id: number,
  name: string,
  payment_method_type: $Values<typeof paymentTypes>,
}

export type PaymentMethodState = {
  content: {
    data: Array<PaymentMethod>,
  },
  loading: boolean,
  request: {
    paymentMethods: (void) => Promise<void>,
  },
  error?: { [string]: mixed },
}

const initialContent = {
  data: [],
};

export type Props = {
  children: React.Node | (value: PaymentMethodState) => React.Node,
}

const PaymentMethodsApi = ({ children }: Props) => (
  <Api
    fnApi={shopApi}
    apiData={PaymentMethods}
    descriptions={requestsData}
    initialContent={initialContent}
  >
    {children}
  </Api>
);

export default PaymentMethodsApi;
